import React from "react";

const Fish = props => (
  <svg viewBox="0 0 100 100" {...props}>
    <g fill="none">
      <circle fillOpacity={0.8} fill="#4A4A4A" cx={50} cy={50} r={50} />
      <path
        d="M50.997 99.987c24.793-.485 45.16-19.015 48.515-43L85.126 42.6 44.867 61.55 23.344 40.029l-5.19 20.592-6.76-.236 39.603 39.603z"
        fill="#4A4A4A"
      />
      <path
        d="M61.736 35.417c-13.1 0-28.122 3.293-35.73 8.087-1.833-3.562-5.125-5.939-8.884-5.939-2.117 0-4.085.756-5.729 2.051 2.824 2.224 4.688 6.043 4.688 10.384 0 4.34-1.864 8.16-4.688 10.384 1.644 1.295 3.612 2.05 5.73 2.05 3.758 0 7.05-2.376 8.882-5.939 7.609 4.794 22.631 8.088 35.731 8.088 18.446 0 26.09-6.53 26.09-14.583 0-8.055-7.645-14.583-26.09-14.583z"
        fill="#FE9A35"
      />
      <path
        d="M16.08 49.981V50c0 4.34-1.863 8.16-4.687 10.384 1.644 1.295 3.612 2.05 5.73 2.05 3.758 0 7.05-2.376 8.882-5.938 7.609 4.793 22.631 8.087 35.731 8.087 18.446 0 26.09-6.529 26.09-14.583v-.019H16.08z"
        fill="#FF7C11"
      />
      <path
        d="M62.425 35.42A20.7 20.7 0 0 0 56.445 50a20.7 20.7 0 0 0 5.98 14.58c17.946-.162 25.4-6.627 25.4-14.58s-7.454-14.418-25.4-14.58z"
        fill="#F9C41E"
      />
      <path
        d="M56.445 49.981V50a20.7 20.7 0 0 0 5.98 14.58c17.946-.162 25.4-6.627 25.4-14.58v-.019h-31.38z"
        fill="#FE9A35"
      />
      <circle fill="#4D4D4D" cx={77.344} cy={47.525} r={2.148} />
    </g>
  </svg>
);

export default Fish;



// WEBPACK FOOTER //
// ./src/components/Icons/Fish.js